// src/pages/ScanPage.js
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Html5QrcodeScanner } from 'html5-qrcode';
import { getItemByQR } from '../services/api';

export default function ScanPage() {
  const navigate = useNavigate();
  const [status, setStatus] = useState('scanning');
  const [error, setError] = useState('');
  const scannerRef = useRef(null);
  const processingRef = useRef(false);

  useEffect(() => {
    let scanner = null;

    const timer = setTimeout(() => {
      try {
        scanner = new Html5QrcodeScanner('qr-reader', {
          fps: 5,
          qrbox: { width: 250, height: 250 },
          aspectRatio: 1.0,
          showTorchButtonIfSupported: true,
        }, false);

        scanner.render(onScanSuccess, () => {});
        scannerRef.current = scanner;
      } catch (err) {
        console.error('Scanner init error:', err);
      }
    }, 200);

    return () => {
      clearTimeout(timer);
      processingRef.current = true;
      if (scanner) {
        scanner.clear().catch(() => {});
      }
      scannerRef.current = null;
    };
  }, []);

  const stopScanner = () => {
    if (scannerRef.current) {
      try {
        scannerRef.current.clear().catch(() => {});
      } catch (e) {}
      scannerRef.current = null;
    }
  };

  const onScanSuccess = async (decodedText) => {
    if (processingRef.current) return;
    processingRef.current = true;

    stopScanner();
    setStatus('loading');

    try {
      let qrCodeId = decodedText.trim();

      if (decodedText.includes('/scan/')) {
        qrCodeId = decodedText.split('/scan/')[1].split('?')[0].trim();
      } else if (decodedText.includes('/item/')) {
        const itemId = decodedText.split('/item/')[1].split('?')[0].trim();
        navigate(`/item/${itemId}`);
        return;
      }

      const res = await getItemByQR(qrCodeId);
      navigate(`/item/${res.data.item.item_id}`);

    } catch (err) {
      const is404 = err.response?.status === 404;
      setError(
        is404
          ? 'QR code not recognized. This item may not be registered in NGC Tracker yet.'
          : 'Connection error. Check your signal and try again.'
      );
      setStatus('error');
    }
  };

  const handleScanAgain = () => {
    processingRef.current = false;
    setStatus('scanning');
    setError('');

    setTimeout(() => {
      try {
        const scanner = new Html5QrcodeScanner('qr-reader', {
          fps: 5,
          qrbox: { width: 250, height: 250 },
          aspectRatio: 1.0,
          showTorchButtonIfSupported: true,
        }, false);
        scanner.render(onScanSuccess, () => {});
        scannerRef.current = scanner;
      } catch (e) {
        console.error('Scanner reinit error:', e);
      }
    }, 300);
  };

  return (
    <div className="screen">
      <div className="screen-header">
        <h2>Scan Tool</h2>
      </div>

      <div className="screen-content" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: 24 }}>

        {status === 'scanning' && (
          <>
            <p style={{ color: 'var(--text-secondary)', marginBottom: 16, textAlign: 'center' }}>
              Point your camera at a tool's QR code
            </p>
            <div id="qr-reader" style={{ width: '100%', maxWidth: 400 }} />
          </>
        )}

        {status === 'loading' && (
          <div className="loading">
            <div className="spinner" />
            <span>Looking up item...</span>
          </div>
        )}

        {status === 'error' && (
          <div style={{ textAlign: 'center', padding: '32px 16px' }}>
            <div style={{ fontSize: '3rem', marginBottom: 16 }}>❌</div>
            <div className="alert alert-error" style={{ marginBottom: 24 }}>{error}</div>
            <button className="btn btn-primary" onClick={handleScanAgain}>
              Scan Again
            </button>
          </div>
        )}

      </div>
    </div>
  );
}
